import { updateNumberOfLikes } from "../../../../lib/prisma-db";

export async function PATCH(request, { params }) {
  const { id } = await params;
  const mediaId = parseInt(id, 10);
  const { liked } = await request.json();

  const response = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/media/${mediaId}`);
  const media = await response.json();

  const newNumberOfLikes = liked
    ? media.likes + 1
    : Math.max(0, media.likes - 1);

  await updateNumberOfLikes(mediaId, newNumberOfLikes);

  return Response.json({ likes: newNumberOfLikes });
}
